<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Files</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <div slot="table-actions-bottom">
              <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'who'">
                <v-layout align-center justify-start row fill-height>
                  <v-flex xs12>
                    {{ props.row.User.fullName }}
                  </v-flex>
                </v-layout>
              </span>
              <span v-else-if="props.column.field == 'actions'">
                <div class="text-xs-center">
                  <v-btn fab small :href="props.row.filePath" target="_blank" color="primary">
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </div>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit File</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xm12 class="title text-xs-center text-sm-left align-center">
                <v-select
                  :items="searchSelect"
                  v-model="editDocument.year"
                  label="Year"
                  small
                  solo
                ></v-select>
              </v-flex>
              <v-flex xm12 class="title text-xs-center text-sm-left align-center">
                <v-select
                  :items="categories"
                  v-model="editDocument.FileCategoryId"
                  label="Category"
                  small
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editDocument.name"
                  @keyup.enter="save"
                  label="Document Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='editDocument.fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="*/*"
                  @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'list',
      searchSelect: [],
      searchType: '',
      currentYear: 0,
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'File',
          field: 'fileName',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Date',
          field: 'createdAt',
          thClass: 'text-center',
          html: true
        },
        // {
        //   label: 'Who',
        //   field: 'who',
        //   thClass: 'hidden-sm-and-down text-center',
        //   tdClass: 'hidden-sm-and-down',
        //   type: 'text'
        // },
        {
          label: 'Year',
          field: 'year',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      evalItem: {},
      showEvalForm: false,
      memberList: [],
      files: [],
      editDocument: {},
      categories: []
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getFiles()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    '$route.params.committee': function (committee) {
      this.isTableLoading = true
      this.loading = true

      this.getVendors()
      this.getCategories()
      this.loading = false
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    async getCategories () {
      try {
        const response = await Api().get('all_categories/')
        this.categories = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.editDocument.fileName = files[0].name
        // Check validity of file
        if (this.editDocument.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
        })
      } else {
        this.editDocument.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row
      this.showEvalForm = true
    },

    async getFiles () {
      this.isCommChair = false

      try {
        const response = await Api().get('vendor_files/' + this.item.id)

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.saving = false
          this.snackbar.message = 'There were errors in the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          if (!this.editDocument.committee) {
            this.editDocument.committee = ''
          }

          if (!this.editDocument.notes) {
            this.editDocument.notes = ''
          }

          if (this.editDocument.id > 0) {
            this.updateItem()
          } else {
            this.addItem()
          }
        }
      })
    },

    async addItem () {
      let filenames = []

      let formData = new FormData()
      formData.append('name', this.editDocument.name)
      formData.append('year', this.editDocument.year)
      formData.append('fileName', this.editDocument.fileName)
      formData.append('UserId', this.myId)
      formData.append('VendorCompanyId', this.item.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_files', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.documents = []
        this.getFiles()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        this.editDocument.UserId = this.userId

        const response = await Api().put('documents/' + this.editDocument.id, this.editDocument)

        this.documents = []
        this.getFiles()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteDocument (documentId) {
      let r = confirm('Are you sure you want to remove this document?')

      if (r === true) {
        try {
          const response = await Api().delete('documents/' + documentId)

          this.documents = []
          this.getDocuments()
          this.dialogShow = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    close () {
      this.editDocument = {}

      this.dialog = false
      this.dialogShow = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/FileList.vue